import moment from "moment";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import Card from "../../../components/Card";
import { SearchBySpecialtyRes } from "../../../models";
import { httpGET } from "../../../utils/ajaxHelper";
import { ISearchBySpecialtyProps } from "./searchBySpecialty.props";
import { Container } from "./searchBySpecialty.styled";

export const SearchBySpecialty = ({ interval, comOfferingType, orgFilter }: ISearchBySpecialtyProps) => {
    const [searchBySpecialty, setSearchBySpecialty] = useState<SearchBySpecialtyRes[]>();
    const { mutate: searchBySpecialtyFetch } = useMutation(
        () =>
            httpGET({
                url: "/DashboardReport/search-by-specialty",
                params: {
                    interval,
                    timeZone: new Date().getTimezoneOffset() / (-60),
                    currentDate: moment().format("MM/DD/YYYY").toString(),
                    offeringType: comOfferingType?.value,
                    orgId: orgFilter?.value
                }
            }),
        {
            onSuccess: (rs) => {
                setSearchBySpecialty(rs);
            },
        },
    );

    useEffect(() => {
        searchBySpecialtyFetch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comOfferingType, orgFilter])

    useEffect(() => { searchBySpecialtyFetch() }, [interval]);

    if (!searchBySpecialty) {

        return null;
    }
    return (
        <Card style={{ height: "100%", overflow: "hidden" }}>
            <Container className="custom-scroll" >
                <h2>
                    Search By Specialty
                </h2>

                {searchBySpecialty?.length > 0 ? (<div className="main min-w-[210px] ">
                    {searchBySpecialty && (
                        searchBySpecialty.map((e, i) => {
                            return (
                                <div key={i} className="item flex justify-between">
                                    <p className="left !min-w-[160px]">
                                        {e.comMainService?.mainServiceName}
                                    </p>
                                    <p className="right text-right ">
                                        {e.count}
                                    </p>
                                </div>
                            );
                        })
                    )}
                </div>) : (<div className="no-result">
                    No results found.
                </div>)}

            </Container>
        </Card>
    );
}